import React from "react";

const SpotlightOverlay = ({ targetSelector }) => {
  const element = document.querySelector(targetSelector);

  if (!element) return null;

  const rect = element.getBoundingClientRect();

  return (
    <>
      {/* DARK OVERLAY */}
      <div style={{
        position: "fixed",
        inset: 0,
        // background: "rgba(0,0,0,0.5)",
        background: "rgba(0,0,0,0.25)",
        zIndex: 9998,
        pointerEvents: "none",
        maskImage: `radial-gradient(
        circle at ${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px,
        transparent 120px,
        black 130px
      )`,
      WebkitMaskImage: `radial-gradient(
        circle at ${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px,
        transparent 120px,
        black 130px
      )`,
      }} />

      {/* HIGHLIGHT BOX */}
      <div style={{
        position: "fixed",
        top: rect.top - 4,
        left: rect.left - 4,
        width: rect.width + 8,
        height: rect.height + 8,
        border: "2px solid #1677ff",
        borderRadius: 6,
        zIndex: 9999,
        pointerEvents: "none",
      }} />

      {/* ARROW */}
      <div style={{
        position: "fixed",
        top: rect.top - 40,
        left: rect.left,
        color: "#fff",
        zIndex: 10000,
      }}>
        ⬇ Click here
      </div>
    </>
  );
};

export default SpotlightOverlay;